import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: null };
  }

  static getDerivedStateFromError(error) {
    return { err: error };
  }

  render() {
    if (this.state.err) {
      const msg = this.state.err && this.state.err.message;
      return (
        <div
          style={{
            padding: 24,
            minHeight: '100vh',
            boxSizing: 'border-box',
            background: '#1a1025',
            color: '#ffb4b4',
            fontSize: 14,
            lineHeight: 1.6,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          <p style={{ color: '#fff', marginBottom: 12, fontWeight: 600 }}>
            页面渲染失败
          </p>
          <p style={{ color: 'rgba(255,255,255,0.75)', marginBottom: 12 }}>
            若使用 Safari 无痕或限制跟踪，请换普通标签页；仍不行可换 Chrome。
          </p>
          {msg ? <code style={{ fontSize: 12 }}>{msg}</code> : null}
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RootErrorBoundary>
    <App />
  </RootErrorBoundary>
);
